import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env';
import { map } from 'rxjs';
import { Banner } from '../interfaces/banner';

const ROOT_API = environment.apiUrl + 'guest/';

@Injectable({
  providedIn: 'root',
})
export class BannerService {
  constructor(private http: HttpClient) {}

  getBanners() {
    return this.http.get<Banner>(ROOT_API + 'banners').pipe(
      map((res: any) => {
        const banner = res['data'];
        return banner;
      })
    );
  }

  getMobileBanners() {
    return this.http.get<Banner>(ROOT_API + 'mobile_banners').pipe(
      map((res: any) => {
        const banner = res['data'];
        return banner;
      })
    );
  }
}
